export const TableComponent = {
    template: require('./table-component.html'),
    controller: class TableComponent {
        private settings: any;
        private callback: Function;

        sort(sortField: string, sortDirection: number) {
            this.settings.sortField = sortField;
            this.settings.sortDirection = sortDirection;
            this.callback();
        }
    },
    bindings: {
        headerColumns: '<',
        settings: '=',
        callback: '<',
        templateUrl: '@'
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/table-component/table-component.ts